<script setup>

import { usePage } from '@inertiajs/vue3'

const page = usePage()

defineProps({
    mode: {
        type: String,
        default: 'light' // default to light mode
    }
});
</script>
<template>
    <img
        :src="mode === 'dark' ? (page.props.app_settings?.logo_white || '/images/logo-white.png') : (page.props.app_settings?.logo || '/images/logo.svg')"
        alt="Logo"
    />
</template>
